/*
 * Copyright (c) 2020.
 * Simon
 */

import {
    HEAR_CREATE_FAILURE,
    HEAR_CREATE_REQUEST,
    HEAR_CREATE_SUCCESS,
    HEAR_FANPAGE_STARTED_ATTACH_FAILURE,
    HEAR_FANPAGE_STARTED_ATTACH_REQUEST,
    HEAR_FANPAGE_STARTED_ATTACH_SUCCESS,
    FANPAGE_GET_HEARS_REQUEST,
    FANPAGE_GET_HEARS_SUCCESS,
    FANPAGE_GET_HEARS_FAILURE,
} from '../types';

/**
 * @param {*} state
 * @param {*} action
 */
const HearFanpageStartedReducer = (state = {}, action) => {
    switch (action.type) {
        case FANPAGE_GET_HEARS_REQUEST:
        case FANPAGE_GET_HEARS_SUCCESS:
        case FANPAGE_GET_HEARS_FAILURE:
        case HEAR_FANPAGE_STARTED_ATTACH_FAILURE:
        case HEAR_FANPAGE_STARTED_ATTACH_REQUEST:
        case HEAR_FANPAGE_STARTED_ATTACH_SUCCESS:
        case HEAR_CREATE_FAILURE:
        case HEAR_CREATE_REQUEST:
        case HEAR_CREATE_SUCCESS:
            return {
                ...state,
                data: action.payload
            };
        default:
            return state;
    }
};

export {
    HearFanpageStartedReducer
}